module.exports = (by) => (data) =>
  data.reduce(
    (groups, item) =>
      groups[item.node.frontmatter[by]]
        ? { ...groups, [item.node.frontmatter[by]]: [...groups[item.node.frontmatter[by]], item] }
        : { ...groups, [item.node.frontmatter[by]]: [item] },
    {}
  );
